import { useState } from "react";
import { AutoComplete } from "primereact/autocomplete";

import { requests } from "../../../../../../services/http-common";
import { EmployeeRolesMapping } from "../../../../../../models/Employee";
import { getInitialsFromName } from "../../../../../../helpers/helperFunctions";

import classes from "./NewDirectMessage.module.scss";
import { Employee } from "../../../../../../models/Employee";
import { useKeycloakContext } from "../../../../../../keycloak";

interface NewDirectMessageProps {
  onSelect: (data: any) => void;
  onBackClick: () => void;
}

interface IOption {
  firstName: string;
  lastName: string;
  role: keyof typeof EmployeeRolesMapping;
}

export const NewDirectMessage = ({
  onSelect,
  onBackClick,
}: NewDirectMessageProps) => {
  const [inputValue, setInputValue] = useState<string>("");
  const [suggestions, setSuggestions] = useState<Employee[]>([]);
  const keycloakContext = useKeycloakContext();
  const subId = keycloakContext?.keycloak?.tokenParsed.sub;

  const handleSelect = (e: { value: IOption }) => {
    setInputValue("");
    onSelect(e.value);
  };

  const itemTemplate = (options: IOption) => {
    return (
      <div className={classes.searchItem}>
        <div className={classes.icon}>
          {getInitialsFromName(options.firstName + " " + options.lastName)}
        </div>
        <div className={classes.info}>
          <p>
            {options.firstName} {options.lastName}
          </p>
          <span>{EmployeeRolesMapping[options.role]}</span>
        </div>
      </div>
    );
  };

  const search = (e: { query: string }) => {
    requests
      .get(`/user?filter=${e.query}`)
      .then((res: { result: Employee[] }) => {
        setSuggestions(res.result.filter((e) => e.id !== subId));
      });
  };

  return (
    <div className={classes.newDirectMessage}>
      <div className={classes.header}>
        <i
          onClick={onBackClick}
          className="pi pi-angle-left"
          style={{ fontSize: "24px", cursor: "pointer" }}
        />
        <h3>New Message</h3>
      </div>
      <AutoComplete
        completeMethod={search}
        onChange={(e) => {
          setInputValue(e.value);
        }}
        field="name"
        placeholder="Search employee"
        suggestions={suggestions}
        value={inputValue}
        delay={500}
        onSelect={handleSelect}
        itemTemplate={itemTemplate}
      />
    </div>
  );
};
